module.exports = __webpack_public_path__ + "static/media/page-line-white.d5e77e86.svg";